export const CLIPPER_FEATURE_NAG_DISMISSED_KEY =
  'autoclipper:clipper-feature-nag:dismissed';

export type ClipperFeatureNagDestination = 'community-library' | 'earn';

export const clipperFeatureNagSession = new Set<string>();

export function clipperFeatureNagSeenKey(
  destination: ClipperFeatureNagDestination,
): string {
  return `autoclipper:clipper-feature-nag:seen:${destination}`;
}

type ClipperFeatureNagStorage = Pick<Storage, 'getItem' | 'setItem'> | null;

function isStorageDismissed(storage: ClipperFeatureNagStorage): boolean {
  if (!storage) return false;

  try {
    return storage.getItem(CLIPPER_FEATURE_NAG_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

function isDestinationSeenInStorage(
  storage: ClipperFeatureNagStorage,
  destination: ClipperFeatureNagDestination,
): boolean {
  if (!storage) return false;

  try {
    return storage.getItem(clipperFeatureNagSeenKey(destination)) === '1';
  } catch {
    return false;
  }
}

export function shouldShowClipperFeatureNag({
  storage,
  session,
  objective,
  destination,
}: {
  storage: ClipperFeatureNagStorage;
  session: ReadonlySet<string>;
  objective: string;
  destination: ClipperFeatureNagDestination;
}): boolean {
  if (objective !== 'own_brand') return false;
  // Acervo for own_brand keeps the page but blurs cards; a banner replaced this nag.
  if (destination === 'community-library') return false;
  if (session.has(destination) || session.has('dismissed')) return false;
  if (isStorageDismissed(storage)) return false;
  if (isDestinationSeenInStorage(storage, destination)) return false;

  return true;
}

export function recordClipperFeatureNagAcknowledgement({
  storage,
  session,
  destination,
  dismissAll,
}: {
  storage: ClipperFeatureNagStorage;
  session: Set<string>;
  destination: ClipperFeatureNagDestination;
  dismissAll: boolean;
}): void {
  session.add(destination);
  if (dismissAll) {
    session.add('dismissed');
  }

  if (!storage) return;

  try {
    storage.setItem(clipperFeatureNagSeenKey(destination), '1');
    if (dismissAll) {
      storage.setItem(CLIPPER_FEATURE_NAG_DISMISSED_KEY, '1');
    }
  } catch {
    // Educational persistence must never block navigation.
  }
}
